/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IColumnas from 'Infotrack@Modelos/smartStock/columnas/entidades/columnas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import ColumnasCM from '../controladorModelo/columnasCM';
import { acciones, IEstadoColumnas } from '../reductorColumnas';
import ColumnasVista from '../vista/tablaColumnasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const columnasCM = new ColumnasCM();

const TableColumnasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [columnass, setColumnass] = React.useState<IColumnas[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoColumnas>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarColumnas();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarColumnas = () => {
        manejadorIndicadorCargaGlobal(true);
        columnasCM.consultarColumnasPorFiltro({EmpresaId:idEmpresa}).then((columnass) => {
            setColumnass(modificarPropiedadesColumnas(columnass));
            manejadorIndicadorCargaGlobal(false);
        });
    };

    const modificarPropiedadesColumnas = (columnas: IColumnas[]) => {
        return columnas.map((columna) => ({
            ...columna,
            Estado: columna.Estado !== 1 ? 0 : columna.Estado,
        }));
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadColumnas?: IColumnas) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadColumnas, tipoFormulario } });
    };

    const confirmarEliminacion = (columnas: IColumnas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarColumnas(columnas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarColumnas = (columnas: IColumnas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        columnasCM.eliminarColumnas(columnas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ColumnasVista
            columnass={columnass}
            cargarColumnas={cargarColumnas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableColumnasCV;
